export { default } from './ProductCategoriesSlider';
